import { render, staticRenderFns } from "./ChatWindow.vue?vue&type=template&id=31874d1e&scoped=true&"
import script from "./ChatWindow.vue?vue&type=script&lang=js&"
export * from "./ChatWindow.vue?vue&type=script&lang=js&"
import style0 from "./ChatWindow.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ChatWindow.vue?vue&type=style&index=1&id=31874d1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31874d1e",
  null
  
)

export default component.exports